<template>
<!-- 中间表 -->
    <div class="container" :class="isMenuCollapse? 'hidemenu' : ''">
        <!-- 左边 -->
        <div class="left-container">

            <div class="menu-box">
                <!-- 切换菜单按钮 -->
                <hamburger :is-active="isMenuCollapse" class="hamburger-container" @toggleClick="toggleSideBar" />
            
                <el-input placeholder="请输入内容" size="small" v-model="search" clearable v-if="!isMenuCollapse" style="width:96%;" ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                <div class="title-box">
                    <span v-if="!isMenuCollapse">表名</span>
                    <i class="el-icon-circle-plus-outline icon" title="新建分组" @click="handleAddMenu"></i>
                </div>
            </div>
            <div class="menu-list">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <el-menu :default-active="activeName" :collapse="isMenuCollapse" :default-openeds="openeds" :collapse-transition="false" mode="vertical" @select="handleSelect">
                        <menu-item v-for="item in menuOptions" :key="item.id" :isMenuCollapse="isMenuCollapse" :item="item" :allotGroup="handleAssign" :renewList="getMenu" />
                    </el-menu>
                </el-scrollbar>
            </div>
        </div>

        <!-- 右边 -->
        <div class="main">
            <!-- 内容区域 -->
            <content-table ref="content" @renewList="getMenu"></content-table>
        </div>

        <!-- 新增菜单弹窗 -->
        <el-dialog title="新增" v-if="dialogAddMenu" :visible.sync="dialogAddMenu"  :close-on-click-modal="false" width="600px" top="10vh">
            <el-form :model="menuAddForm" :rules="ruleAddForm" ref="menuAddForm" label-width="100px" >
                <!-- <el-form-item label="父级组名" prop="groupId">
                    <el-select  v-model="postForm.groupId" placeholder="请选择" >
                    <el-option v-for="item in groupOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item label="组名" prop="name">
                    <el-input size="small" v-model="menuAddForm.name" style="width: 200px"></el-input>
                </el-form-item>
            </el-form>

            <!-- 按钮组 -->
            <div class="butn-box" style="text-align: right">
                <el-button type="primary" @click="handleAddMenuSave" >确认</el-button>
                <el-button @click="dialogAddMenu=false">关闭</el-button>
            </div>

        </el-dialog>


        <!-- 分组弹窗 -->
        <el-dialog title="分组配置" v-if="dialogMenu" :visible.sync="dialogMenu" :close-on-click-modal="false" append-to-body width="600px" top="10vh">
            <el-form :model="postForm" :rules="ruleForm" ref="postForm" label-width="100px" >
                <el-form-item label="组名" prop="groupId">
                    <el-select  v-model="postForm.groupId" placeholder="请选择" >
                    <el-option v-for="item in groupOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <!-- 按钮组 -->
            <div class="butn-box" style="text-align: right">
                <el-button type="primary" @click="handleMenuSave" >确认</el-button>
                <el-button @click="dialogMenu=false">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import Hamburger from '@/components/Hamburger'
import MenuItem from './components/menuItem.vue'
import ContentTable from './components/contentTable'
import {ajax_dataworkMenuList, ajax_configGroup, ajax_updateGroup} from '@Bdc~/api/ajax_model'

// 弹窗默认的数据内容
const defaultFrom = {
  name: ''
}
export default {
    components: {Hamburger, MenuItem, ContentTable},
    data() {
        return {
            isMenuCollapse: false, // 导航栏是否打开
            // 菜单列表
            menuData:[],
            originalMenuData:[],
            groupOptions: [], // 所有组名
            activeName: null, // 当前激活菜单

            search: '', // 搜索

            // 新增菜单弹窗
            dialogAddMenu: false,
            menuAddForm: {},
            ruleAddForm:{
                name: { required: true, message: '请填写表名', trigger: 'blur' }
            },

            // 配置分组
            dialogMenu: false,
            postForm: {
                groupId: '',
                eventCode:''
            },
            ruleForm: {
                groupId:{required: true, message: '请选择组名', trigger: ['blur','change'] }
            }
        }
    },

    computed: {
        // 模糊搜索 菜单
        menuOptions() {
            const search = this.search.replace(/^\s+|\s+$/g,"")
            this.menuData = JSON.parse(JSON.stringify(this.originalMenuData))
            if(search) {
               this.filterEventDesc(this.menuData, search)
            }
            // console.log('========33333',this.menuData)
            return this.menuData
        },

        openeds() {
            let openeds = []
            if(this.search) {
                this.filteropeneds(this.menuData, openeds)
            }
            // console.log(openeds)
            return openeds
        }
    },

    created() {
        this.getMenu() // 获取菜单列表
    },

    methods: {
        // 获取菜单列表
        getMenu() {
            ajax_dataworkMenuList().then(response => {
                if(response.code == 1) {
                    this.originalMenuData = this.menuData = this.transformData(response.data)

                    this.filterDefaultActive(this.menuData[0]) // 筛选默认的 eventCode
                    this.$refs['content'].getList(this.activeName) // 初始化详情

                } else {
                    this.$message.error( response.msg);
                }
            })
        },

        // 转换数据
        transformData(list) {
            let tmp = []
            let groups = []
            list.map(v => {
                this.$set(v, 'edit', false)
                this.$set(v, 'originalName', v.name)

                tmp.push(v)

                groups.push(v)

                if(v.children && v.children.length > 0) {
                    const res = this.transformData(v.children)
                    groups = groups.concat(res)
                }
            })
            this.groupOptions = groups

            // console.log('11111=========', this.groupOptions)

            return tmp

        },

        // 筛选默认的 eventCode
        filterDefaultActive(list) {
            if(list.data && list.data.length > 0) {
                // console.log('11111active:',list.data[0].eventCode)
                this.activeName = list.data[0].eventCode
                return true
            }
            if(list.children && list.children.length > 0) {
                this.filterDefaultActive(list.children[0])
            }
        },

         // 筛选表名 递归
        filterEventDesc(data,search) {
            data.forEach(v => {
                if(v.data && v.data.length > 0) {
                    v.data = v.data.filter(menu => {
                        // return Object.keys(menu).some(key => {
                            return String(menu['eventDesc']).toLowerCase().indexOf(search) >= 0
                        //})
                    })
                }
                if(v.children && v.children.length > 0) {
                    this.filterEventDesc(v.children, search)
                }
                // console.log('11111111',v)
                return v
            })
        },

        // 筛选默认打开菜单 递归
        filteropeneds(list, openeds) {
            list.forEach(item => {
                if(item.data && item.data.length > 0 ) {
                    openeds.push(String(item.id))
                }

                if(item.children && item.children.length > 0) {
                    this.filteropeneds(item.children, openeds)
                }
            })
        },

        // 新增菜单
        handleAddMenu() {
            this.menuAddForm = JSON.parse(JSON.stringify(defaultFrom)) // 深复制
            this.dialogAddMenu = true
            this.$nextTick(() => {
                this.$refs['menuAddForm'].clearValidate()
            })
        },

        // 保存新增菜单
        handleAddMenuSave() {
            this.$refs['menuAddForm'].validate((valid) => {
                if (valid) {
                    ajax_updateGroup('', 0, this.menuAddForm.name).then(response => {
                        if(response.code == 1) {
                            this.dialogAddMenu = false
                            this.$message({
                                message: '添加组成功',
                                type: 'success'
                            });
                            this.getMenu()
                        }
                    })
                }
            })
        },

        // 将表 分配组
        handleAssign(item) {
            this.dialogMenu = true
            this.postForm.eventCode = item.eventCode
            this.postForm.groupId = ''
            this.$nextTick(() => {
                this.$refs['postForm'].clearValidate()
            })
        },

        // 确认分组
        handleMenuSave() {
            this.$refs['postForm'].validate((valid) => {
                if (valid) {
                const groupId = this.postForm.groupId
                const eventCode = this.postForm.eventCode
                ajax_configGroup(groupId, eventCode).then(response => {
                    if(response.code ==1) {
                    this.dialogMenu = false
                    this.$message({
                        message: '分组配置成功',
                        type: 'success'
                    });

                    this.getMenu() // 重新获取数据
                    }
                })
                }
            })
        },

        // 切换导航
        toggleSideBar() {
            this.isMenuCollapse = !this.isMenuCollapse
        },

        // 切换菜单
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
            this.activeName = key
            this.$refs['content'].getList(key) // 初始化详情
        },
    }
}
</script>

<style lang="scss" scoped>
     @import '@/styles/variables.scss';
    .container{
        min-height: 100%;
        position:relative;
        transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
    }
    // 左边
    .left-container {
        transition: width 0.28s;
        width: 240px; 
        height: 100%;
        position: fixed;
        font-size: 0px;
        top: 103px;
        bottom: 0;
        left:  $sideBarWidth + 15px;
        z-index: 1001;
        border-right: 1px solid #e6e6e6;

        // reset element-ui css
        .horizontal-collapse-transition {
            transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
        }

        .scrollbar-wrapper {
           overflow-x: hidden !important;
           width: 100%;
        }

        ::v-deep .el-scrollbar__wrap{
            overflow-x: hidden !important;
        }

        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }

        .el-scrollbar {
            height: 100%;
        }

        .el-menu {
            border: none;
            height: 100%;
        }

        .menu-list{
            width: 100%;
            height: calc(100vh - 240px);
            overflow: hidden;
        }

        .menu-box{
            width: 100%;
            text-align: center;
            position: relative;
            
            .hamburger-container{
                position: absolute;
                top: -20px;
                right: -30px;
                cursor: pointer;
            }
            .title-box{
                width: 100%;
                height: 30px;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                margin-top: 10px;
                padding: 0 20px;
                background: #dfe6ec;
                transition: width 0.28s;
                span{
                    font-size: 14px;
                    opacity: 1;
                    transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
                }
            }
        }

        .icon{
            font-size: 18px;
            font-weight: bolder;
            cursor: pointer;
            color: #409eff ;
        }

    }

    // 右边
    .main {
        min-height: 100%;
        height: auto;
        transition: all .28s;
        margin-left: 240px;
        position: relative;
        z-index: 1;
        padding: 10px 20px;
    }

    // 折叠侧边栏后
    .hidemenu {
       .left-container{
           width: 40px !important;
           top: 93px;
           .menu-list{
               height: calc(100vh - 240px);
           }
           .title-box{
               justify-content: center;
               span{
                   transition: opacity 5s;
                   opacity: 0;
               }
           }
        } 

        .el-menu--collapse{
            width: 39px !important;
        }

         .main {
            margin-left: 40px;
        }
    }

    // 侧边栏折叠
    .hideSidebar{
        .left-container{
            left:69px !important;
        }
    }

</style>